import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation TransferByEmail($chatId: ID!) {
    transferByEmail(chatId: $chatId) {
      id
    }
  }
`);
